import { z } from 'zod'

export const clientEnv = z
  .object({
    NEXT_PUBLIC_DEPLOYABLE_ENV: z.enum(['stage', 'production', 'local']).default('local'),
    NEXT_PUBLIC_ABSMARTLY_URL: z.string().default('https://nerdwallet.absmartly.io/v1'),
    NEXT_PUBLIC_ABSMARTLY_API_KEY: z.string().default(''),
    NEXT_PUBLIC_SEGMENT_WRITE_KEY: z.string().default('tA4aczWybClzbqaZaenEMUsO0ZcfaEpP'),
    NEXT_PUBLIC_MATCH_URL: z.string().default('https://match.nerdwalletadvisors.biz/find-my-advisor'),
    NEXT_PUBLIC_VERITONIC_ID: z.string().optional(),
    NEXT_PUBLIC_VERITONIC_GDPR: z.string().optional(),
    NEXT_PUBLIC_ONE_TRUST_DATA_DOMAIN_SCRIPT: z.string().optional(),
  })
  .parse({
    NEXT_PUBLIC_DEPLOYABLE_ENV: process.env.NEXT_PUBLIC_DEPLOYABLE_ENV,
    NEXT_PUBLIC_ABSMARTLY_URL: process.env.NEXT_PUBLIC_ABSMARTLY_URL,
    NEXT_PUBLIC_ABSMARTLY_API_KEY: process.env.NEXT_PUBLIC_ABSMARTLY_API_KEY,
    NEXT_PUBLIC_SEGMENT_WRITE_KEY: process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY,
    NEXT_PUBLIC_MATCH_URL: process.env.NEXT_PUBLIC_MATCH_URL,
    NEXT_PUBLIC_VERITONIC_ID: process.env.NEXT_PUBLIC_VERITONIC_ID,
    NEXT_PUBLIC_VERITONIC_GDPR: process.env.NEXT_PUBLIC_VERITONIC_GDPR,
    NEXT_PUBLIC_ONE_TRUST_DATA_DOMAIN_SCRIPT: process.env.NEXT_PUBLIC_ONE_TRUST_DATA_DOMAIN_SCRIPT,
  })

export const isProduction = clientEnv.NEXT_PUBLIC_DEPLOYABLE_ENV === 'production'
